// Minimal theme JS — defer most interactivity to Shopify's built-ins.
// Add behavior here as needed (mobile nav, predictive search, cart drawer).

document.addEventListener("DOMContentLoaded", () => {
  // Newsletter form: surface a thank-you message without leaving the page.
  document.querySelectorAll(".news-form").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      // Let Shopify handle the actual submit. If you want AJAX behavior,
      // swap this for a fetch() against the customer contact endpoint.
    });
  });
});
